export default __webpack_public_path__ + "static/media/v-kool.c5ee9008.jpg";